/* eslint-disable no-shadow */
import React, { useState, useRef, useEffect } from 'react';

import Modal from 'react-bootstrap/Modal';

import ConfirmButton from '../../components/Buttons/ConfirmButton';
import FileDescriptions from './FileDescriptions';
import Files from './Files';

import classes from './styles.module.scss';
import closeIcon from '../../assets/images/closeIcon.svg';

export default function UploadFilesModal({
  show,
  handleClose,
  onSubmit,
  initialFiles,
  withText,
}) {
  const [files, setFiles] = useState([]);
  const [prevFiles, setPrevFiles] = useState([]);
  const [deletedPrevFilesIds, setDeletedPrevFilesIds] = useState([]);
  const [selectedFileId, setSelectedFileId] = useState('');
  const [descriptions, setDescriptions] = useState([]);

  const inputRef = useRef();

  const addFiles = (event) => {
    const addedFiles = Array.from(event.target.files);
    const filteredFiles = addedFiles
      .filter((file) => {
        const fileType = file.type.split('/')[0];
        return fileType === 'image';
      })
      .filter((file) => {
        return (
          !files.some((prevFile) => prevFile.name === file.name) &&
          !prevFiles.some((pFile) => pFile.name === file.name)
        );
      });

    setFiles((prev) => {
      const allFiles = [...prev, ...filteredFiles].slice(
        0,
        Math.max(10 - prevFiles.length, 0)
      );
      return allFiles;
    });

    setSelectedFileId(filteredFiles[0]?.size || '');
  };

  useEffect(() => {
    if (!show) {
      setFiles([]);
      setPrevFiles([]);
      setDeletedPrevFilesIds([]);
      setSelectedFileId('');
      setDescriptions([]);
    }
  }, [show]);

  useEffect(() => {
    if (initialFiles && initialFiles.length > 0) {
      setPrevFiles(initialFiles);
    }
  }, [initialFiles]);

  const noFiles =
    (!files || files.length === 0) && (!prevFiles || prevFiles.length === 0);

  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.UploadFilesModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
    >
      <header className={classes.header}>
        <h1 className={classes.title}>Upload Files</h1>
        <button
          className={classes.closeButton}
          type="button"
          onClick={handleClose}
        >
          <img src={closeIcon} alt="Close" />
        </button>
      </header>
      <Files
        withText={withText}
        prevFiles={prevFiles}
        setPrevFiles={setPrevFiles}
        setDeletedPrevFilesIds={setDeletedPrevFilesIds}
        setSelectedFileId={setSelectedFileId}
        setDescriptions={setDescriptions}
        selectedFileId={selectedFileId}
        files={files}
        setFiles={setFiles}
        inputRef={inputRef}
        noFiles={noFiles}
      />
      {withText && (
        <FileDescriptions
          files={files}
          prevFiles={prevFiles}
          selectedFileId={selectedFileId}
          descriptions={descriptions}
          setDescriptions={setDescriptions}
        />
      )}

      <footer className={classes.footer}>
        <p className={classes.info}>Only images allowed</p>
        <div className={classes.buttons}>
          <ConfirmButton
            style={{ height: 70, width: 70 }}
            onClick={() => {
              if (
                files.length ||
                deletedPrevFilesIds.length ||
                descriptions.length > 0
              ) {
                onSubmit({
                  files,
                  deletedInitialFilesIds: deletedPrevFilesIds,
                  descriptions,
                });
              }

              handleClose();
            }}
          />
        </div>
      </footer>
      <input
        onChange={addFiles}
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        style={{
          display: 'none',
        }}
      />
    </Modal>
  );
}
